import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import CamdetectErrorsTable from '../components/CamdetectErrorsTable';
import CamdetectCamerasSelect from '../components/CamdetectCamerasSelect';
import CamdetectErrorsModel from '../components/CamdetectErrorsModel';

import { Layout, Button, Row, Col, Input, Icon, DatePicker, message } from 'antd';

class CamdetectErrorsScreen extends Component {

  state = {
    dataLoading: false,
    dataAll: [],
    camera: null,
    data: [],
    dateFrom: moment().startOf('day'),
    dateTo: moment().endOf('day')
  }

  onDateRangeChanged(dates, dateStrings) {
    this.setState({
      dateFrom: dates[0],
      dateTo: dates[1]
    });
    this.loadData(this.state.camera, dates[0], dates[1]);
  }

  loadData(camera, dateFrom = null, dateTo = null) {
    dateFrom = dateFrom ? dateFrom.format() : null;
    dateTo = dateTo ? dateTo.format() : null;
    if (camera) {
      this.setState({
        dataLoading: true
      });
      CamdetectErrorsModel.getAll(camera, dateFrom, dateTo)
        .then(data => {
          this.setState({
            dataLoading: false,
            dataAll: data,
            data: data
          });
        })
        .catch(() => {
          message.warning('Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby.')
          this.setState({
            dataLoading: false,
          });
        });
    } else {
      message.warning('Zvolte prosím kameru!');
    }
  }

  onDateRangeChanged(dates, dateStrings) {
    this.setState({
      dateFrom: dates[0],
      dateTo: dates[1]
    });
    this.loadData(this.state.camera, dates[0], dates[1]);
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0', minHeight: 'auto' }}>
        <div style={{ padding: 24, background: '#fff' }}>
          <h2>Kamerová detekce - Chyby</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={10}>
                <CamdetectCamerasSelect
                  onChange={(value) => {
                    this.setState({ camera: value });
                    this.loadData(value, this.state.dateFrom, this.state.dateTo);
                  }}
                  style={{ width: 300 }} />
                {' '}
                <DatePicker.RangePicker
                  defaultValue={[
                    this.state.dateFrom,
                    this.state.dateTo
                  ]}
                  ranges={{
                    "Dnes": [moment().startOf('day'), moment().endOf('day')],
                    "Včera": [moment().add(-1, 'days').startOf('day'), moment().add(-1, 'days').endOf('day')],
                    "Poslední týden": [moment().add(-7, 'days').startOf('day'), moment().endOf('day')],
                  }}
                  allowClear={false}
                  placeholder={['Od', 'Do']}
                  format="DD.MM.YYYY HH:mm"
                  showTime={{ format: 'HH:mm' }}
                  onOk={this.onDateRangeChanged.bind(this)}
                  style={{ width: 300 }} />
              </Col>
              <Col span={5} offset={8} style={{ textAlign: 'right' }}>
                <Button type="default" onClick={() => { this.loadData(this.state.camera, this.state.dateFrom, this.state.dateTo) }} style={{ marginRight: 10 }}><Icon type="sync" /></Button>
              </Col>
            </Row>
          </div>
          <CamdetectErrorsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onDetailRow={(record) => {
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default CamdetectErrorsScreen;



// WEBPACK FOOTER //
// ./src/screens/CamdetectErrorsScreen.js